import type { Session } from "@supabase/supabase-js";

async function parseJson<T>(response: Response) {
  const payload = (await response.json()) as T;
  if (!response.ok) {
    const message = (payload as { error?: string }).error ?? "Request failed";
    throw new Error(message);
  }
  return payload;
}

export async function fetchBootstrap() {
  const response = await fetch("/api/bootstrap");
  return parseJson<{
    appName: string;
    supabaseUrl: string;
    supabasePublishableKey: string;
  }>(response);
}

export async function fetchAuthed<T>(
  session: Session,
  path: string,
  init?: RequestInit
) {
  const response = await fetch(path, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.access_token}`,
      ...(init?.headers ?? {}),
    },
  });

  return parseJson<T>(response);
}
